// @flow

import * as React from 'react';
import numeral from 'numeral';
import { sumBy } from 'lodash/fp';
import styled from '@emotion/styled';

import StarSymbol from 'app/components/challenge/StarSymbol';

import RowHeader from '../commons/RowHeader';

type Props = {
  first?: boolean,
  players: Array<Object>
};

const defaultProps = {
  first: false
};

const Name = styled.span(({ theme }) => ({
  paddingRight: theme.spacing.default,
  [theme.mediaQuery.mobileSmallOnly]: {
    paddingRight: theme.spacing.tiny
  }
}));

const Label = styled.span(({ theme }) => ({
  paddingRight: theme.spacing.tiny
}));

const Value = styled.span(({ theme }) => ({
  fontWeight: theme.fontWeight.normal,
  paddingRight: theme.spacing.default,
  [theme.mediaQuery.mobileSmallOnly]: {
    paddingRight: theme.spacing.tiny
  }
}));

const ProjectedRacingScore: React.FC<Props> = ({ first, players }: Props) => {
  const win = sumBy(p => (p.gamePlaced ? p.win : p.winProjected))(players);
  const place = sumBy(p => (p.gamePlaced ? p.place : p.placeProjected))(players);
  const score = sumBy(p => p.score || p.scoreProjected)(players);

  return (
    <RowHeader first={first} scrollable>
      <div className="columns is-mobile" style={{ alignItems: 'center' }}>
        <div className="column">
          <Name>
            <StarSymbol>Projections</StarSymbol>
          </Name>
        </div>
        <div className="column">
          <Label>Win:</Label>
          <Value>{numeral(win).format('0.00')}</Value>
        </div>
        <div className="column">
          <Label>Place:</Label>
          <Value>{numeral(place).format('0.00')}</Value>
        </div>
        <div className="column">
          <Label>Score:</Label>
          <Value>{numeral(score).format('0.00')}</Value>
        </div>
      </div>
    </RowHeader>
  );
};

ProjectedRacingScore.defaultProps = defaultProps;

export default ProjectedRacingScore;
